import { UserRole } from 'enums/user-roles';

export const isRouteAllowed = (userRole: UserRole, allowedRoles?: UserRole[]) =>
  !allowedRoles || allowedRoles?.includes(userRole);
